import { createEntityCollectionStore, PickActions } from '@recruitee/ngrx';
import type { OAuthClient } from '@recruitee/oauth-types';

const { actions, reducer, namespace, selectors } =
  createEntityCollectionStore<OAuthClient>()('OAuthClient');

const OAuthClientActions: PickActions<typeof actions, 'fetchOne'> = actions;

export {
  OAuthClientActions,
  reducer as OAuthClientReducer,
  namespace as OAuthClientNamespace,
  selectors as OAuthClientSelectors,
};
